// Resolve a URL da API com protecao contra mixed content em ambientes publicados.
const getApiUrl = () => {
  const currentOrigin = window.location.origin;
  const currentProtocol = window.location.protocol;
  const hostname = window.location.hostname;
  const isLocalhostHost = hostname === 'localhost' || hostname === '127.0.0.1';
  const configuredUrl = (process.env.REACT_APP_API_URL || '').trim();

  // Prioridade: valor explícito (ex.: localhost:8000 no .env.development.local).
  // Sem isto, `!localhost` fazia regressão a `currentOrigin` e ignorava o env quando a página
  // não era localhost (tabs em suportnectdev durante testes ao mesmo código).
  if (configuredUrl) {
    try {
      const parsed = new URL(configuredUrl, currentOrigin);
      const isApiLocalhost =
        parsed.hostname === 'localhost' || parsed.hostname === '127.0.0.1';

      if (currentProtocol === 'https:' && parsed.protocol === 'http:' && !isApiLocalhost) {
        parsed.protocol = 'https:';
      }

      return parsed.origin;
    } catch {
      // URL malformada: cai para fallbacks em baixo.
    }
  }

  if (!isLocalhostHost) {
    return currentOrigin;
  }

  // Em localhost sem REACT_APP_API_URL explícito, prioriza backend local.
  // Se precisar forçar outro backend, use REACT_APP_API_URL no .env.
  return 'http://localhost:8000';
};

export const API_URL = getApiUrl();

const readEnv = (value?: string): string => (value || '').trim();

const CURRENT_HOST = window.location.hostname.toLowerCase();
const CURRENT_ORIGIN = window.location.origin.replace(/\/$/, '');
const DEV_HOST = 'suportnectdev.petronect.biz';
const PROD_HOST = 'suportnect.petronect.biz';
const DEV_CLIENT_ID = '22f71d88-f911-4849-93f0-9882f6c4898a';
const PROD_CLIENT_ID = 'ef500ea1-2ed5-44bc-aa6b-7b1f6500fb00';

const resolveAzureClientId = () => {
  // Correlacao fixa por host para evitar mistura de configuracao DEV/PROD.
  if (CURRENT_HOST === DEV_HOST) return DEV_CLIENT_ID;
  if (CURRENT_HOST === PROD_HOST) return PROD_CLIENT_ID;
  return readEnv(process.env.REACT_APP_AZURE_CLIENT_ID);
};

export const AZURE_TENANT_ID = readEnv(process.env.REACT_APP_AZURE_TENANT_ID);
export const AZURE_CLIENT_ID = resolveAzureClientId();
export const AZURE_REDIRECT_URI =
  readEnv(process.env.REACT_APP_AZURE_REDIRECT_URI) || `${CURRENT_ORIGIN}/auth/callback`;
export const AZURE_POST_LOGOUT_REDIRECT_URI =
  readEnv(process.env.REACT_APP_AZURE_POST_LOGOUT_REDIRECT_URI) || `${CURRENT_ORIGIN}/logout/callback`;

export const MICROSOFT_SSO_ENABLED = Boolean(
  AZURE_TENANT_ID &&
    AZURE_CLIENT_ID &&
    AZURE_REDIRECT_URI &&
    AZURE_POST_LOGOUT_REDIRECT_URI
);



